import React, { useEffect, useState } from "react";
import MOQ from "../components/MOQ";
import instance from "../utils/instance";
import ContentLoader from "react-content-loader";
import { getSessionId } from "../utils/cookieSessionGenerator";

const BlockLoader = ({
  height = 300,
  width = "100%",
  radius = 8,
  uniqueKey = "unique",
}) => (
  <ContentLoader
    uniqueKey={uniqueKey}
    speed={2}
    width={width}
    height={height}
    backgroundColor="#ECEBEB"
    foregroundColor="#b0b0b0"
  >
    <rect
      x="0"
      y="0"
      rx={`${radius}`}
      ry={`${radius}`}
      width="100%"
      height={`${height}`}
    />
  </ContentLoader>
);

function Index(props) {
  // Props
  const { title = "Recommended for you", exclude = "" } = props;

  // States
  const [moqs, setMoqs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Effects
  useEffect(() => {
    getMoqs();
  }, [exclude]);

  const getMoqs = async (id) => {
    try {
      let sessionId = getSessionId();
      if (!sessionId) return;
      setLoading(true);
      const response = await instance.get(`moq/recommended/${sessionId}`);
      setLoading(false);
      if (response.data.moqs) {
        let data = response.data.moqs || [];
        // Exclude items if exclude prop is provided
        if (exclude) {
          const excludeLower = exclude.toLowerCase();
          data = data.filter((item) => {
            const moq_slug = item?.moq_slug?.toLowerCase?.() || "";
            return !(
              moq_slug.includes(excludeLower)
            );
          });
        }
        // Slice the filtered array to limit to twelve items
        data = data.slice(0, 12);
        setMoqs(data);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // Return an empty component if no MOQs are available
  if (!loading && moqs.length === 0) return;

  return (
    <div className="flex flex-col w-full space-y-4 mb-8">
      <h2 className="text-tangerine font-bold uppercase">{title}</h2>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-2">
        {loading &&
          Array(12)
            .fill(null)
            .map((_, i) => (
              <BlockLoader
                key={i}
                uniqueKey={`key${i}`}
                height={300}
                radius={6}
              />
            ))}
        {!loading &&
          moqs.length > 0 &&
          moqs.map((moq, i) => <MOQ key={i} moq={moq} />)}
      </div>
    </div>
  );
}

export default Index;
